import moment from 'moment';
import { PPTextField } from 'processor-plataform-ui';
import React, { useState, useEffect } from 'react';
import TextTools from "../../../../services/TextTools/TextTools";
import Parse from "html-react-parser";
import LcAccordion from '../../../../components/Generic/LcAccordion';
import GenerativeIaEvaluationService from "../../../../services/GenerativeIaEvaluationService/GenerativeIaEvaluationService";
import './index.css';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/index';
import { UserState } from '../../../../store/reducers/userReducer';
import HHCommentAI from '../../../../components/Generic/HHCommentAI';
import { NewSumaryParams, setNewSummary } from '../../../../components/Generic/HHContentAI/generativeIaUtils';
import { CommentNotificationState } from '../../../../store/reducers/commentNotificationReducer,';
import LcLoading from '../../../../components/Generic/LcLoading';

interface Props {
    formEndSolicitation: any,
    solutionTypeText: string,
    classificationGroupText: string,
    classificationText: string,
    solicitation: any
    activeTab: number
    reloadSummaryConclusion?: boolean
    user: any
    solutionText: string
}

const SolicitationConclusionData: React.FC<Props> = (props) => {
    const user = useSelector<RootState, UserState>(state => state.user);

    const textTools = new TextTools();
    const generativeIaEvaluationService = new GenerativeIaEvaluationService(props);
    const commentNotification = useSelector<RootState, CommentNotificationState>(state => state.commentNotificationReducer);

    const [loading, setLoading] = useState(false);
    const [summaryText, setSummaryText] = useState("");
    const [showSummary, setShowSummary] = useState<boolean>(false);
    const [activeAi, setActiveAi] = useState<any>();
    const dispatch = useDispatch();

    useEffect(() => {
        CheckAiConfig();
    }, [props.solicitation])

    useEffect(() => {
        if (props.solicitation && props.reloadSummaryConclusion || commentNotification[props.solicitation.id]?.sumarization) {
            setShowSummary(true);
            // setLoading(true);
            // getSummary();
        }else  {
            setShowSummary(false);
        }
    }, [props.solicitation, props.reloadSummaryConclusion, commentNotification[props.solicitation.id]?.reloadSumary]);

    const CheckAiConfig = async () => {
        try {
            const response = await generativeIaEvaluationService.CheckAiConfig(props.solicitation.id);
            setActiveAi(response.data);
        }
        catch (error) {
            console.error(error);
        }
    }

    const getSummary = async () => {
        setLoading(true);

        try {
            const response = await generativeIaEvaluationService.GetGenerativeIaEvaluationList(props.solicitation.id);
            var commentSummary = response.data.filter(x => x.recordType === 1);

            if (commentSummary.length > 0) {
                var textString = JSON.stringify(commentSummary[0].text).replaceAll("\\n", "<br>");
                var _text = JSON.parse(textString);
                setSummaryText(_text);
            }
        }
        catch (error) {
            console.error(error);
        }
    }

    const handleNewSumary = () => {
        let solicitationParams: NewSumaryParams = {
            solicitationId: props.solicitation.id,
            IdUser: user.id || 0,
            recordType: 1,
            numberOfComments: commentNotification[props.solicitation.id].numberOfComments,
            conclusionText: props.solicitation.closeDetails
        }
        setNewSummary(solicitationParams, dispatch, props);
        setShowSummary(true);
    }

    return (
        <>
            {
                props.activeTab === 4 &&
                <div style={{ display: "flex", width: '100%' }}>
                    <div className={`form${(props.activeTab === 4) ? "" : " hide"}`} style={{ width: '50%' }} >
                        <div className={"input-12"}>
                            <h5>{`Concluído em ${moment(props.formEndSolicitation.closed).format("DD/MM/YYYY")} às ${moment(props.formEndSolicitation.closed).format("HH:mm")}`}</h5>
                        </div>
                        <div className={"input-12"}>
                            <div className={"input-6"} style={{ width: "90%" }}>
                                <PPTextField
                                    disabled
                                    label={"Tipo de solução"}
                                    value={props.solutionTypeText}
                                    width={"50%"}
                                />
                            </div>
                        </div>
                        <div className={"input-12"}>
                            <div className={"input-6"} style={{ width: "90%" }}>
                                <PPTextField
                                    disabled
                                    label={"Grupo"}
                                    value={props.classificationGroupText}
                                />
                            </div>
                        </div>
                        <div className={"input-12"}>
                            <div className={"input-6"} style={{ width: "90%" }}>
                                <PPTextField disabled label={"Classificação"} value={props.classificationText} />
                            </div>
                        </div>
                        <div className={"input-12"}>
                            <div style={{ margin: "5px" }}>
                                <label className={"labelSolutionTextConclusionTab"}> Solução </label>
                                <div className={"input-6"} style={{ width: "90%" }}>
                                    <div className={"divSolutionTextConclusionTab"}>
                                        <span className={"spanSolutionTextConclusionTab"}>{Parse(textTools.cleanOnlyEmailParse(props.solicitation.closeDetails)) ?? ""}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        activeAi && activeAi.configSummary &&
                        <LcAccordion
                            title={<span style={{ paddingRight: '10px' }}>Sumarização</span>}
                            visible={true}
                            iconNormal
                            width={"50%"}
                        >
                            {
                                showSummary
                                ? 
                                <HHCommentAI summarization  originalText={summaryText} visible={true} handleVisible={() =>undefined} setText={() => undefined} user={props.user} solicitation={props.solicitation}/>
                                : 
                                <button className={"lc-button bg-info"} style={{ margin: "10px" }} onClick={() =>{ setShowSummary(true);  
                                    }}>
                                    Gerar Sumarização <i style={{marginLeft: '3px'}} className={"ppi ppi-lightning-bolt ppi-2x"}/> 
                                    </button>
                                }
                        </LcAccordion>
                    }

                </div>
            }
        </>
    );
};

export default SolicitationConclusionData;